import i18n from 'i18next';

const resources = {
    en: {
        translation: {
            'An official website of the Democratic Republic of Timor-Leste': 'An official website of the Democratic Republic of Timor-Leste',
            'Skip to main content': 'Skip to main content',
            'Search the portal': 'Search the portal',
            'Search': 'Search',
            'About': 'About',
            'Budget & spending': 'Budget & spending',
            'Procurement': 'Procurement',
            'Economy & aid': 'Economy & aid',
            'News': 'News',
            'Publications': 'Publications',
            'Contact': 'Contact',
            'Home': 'Home',
            'English': 'English',
            'Tetum': 'Tetum',
            'Português': 'Português',
            'Change language, current language {{label}}': 'Change language, current language {{label}}',
            'Overview and mandate': 'Overview and mandate',
            'Directorates and offices': 'Directorates and offices',
            'Development partners': 'Development partners',
            'Former Ministers': 'Former Ministers',
            'Minister of Finance': 'Minister of Finance',
            'Organisational structure': 'Organisational structure',
            'Programmes and reform': 'Programmes and reform',
            'Research and analysis': 'Research and analysis',
            'Publications and reports': 'Publications and reports',
            'Treasury documents': 'Treasury documents',
            'Knowledge centre': 'Knowledge centre',
            'Infographics and posters': 'Infographics and posters',
            'Contact the Ministry': 'Contact the Ministry',
            'Careers and vacancies': 'Careers and vacancies',
            'Budget and spending overview': 'Budget and spending overview',
            'Budget and revenue by year': 'Budget and revenue by year',
            'Revenue collections': 'Revenue collections',
            'Tax Authority': 'Tax Authority',
            'Customs Authority': 'Customs Authority',
            'Budget infographics': 'Budget infographics',
            'Open data and statistics': 'Open data and statistics',
            'Staff webmail': 'Staff webmail',
            'LIA AI assistant': 'LIA AI assistant',
            'Track an invoice': 'Track an invoice',
            'Open tenders': 'Open tenders',
            'open tender': 'open tender',
            'open tenders': 'open tenders',
            'Have your say': 'Have your say',
            'Public consultations': 'Public consultations',
            'open for comment': 'open for comment',
            'e-Procurement Portal': 'e-Procurement Portal',
            'Procurement overview': 'Procurement overview',
            'Current tenders': 'Current tenders',
            'Tender archive': 'Tender archive',
            'Register as a supplier': 'Register as a supplier',
            'Procurement legislation': 'Procurement legislation',
            'Guidance and publications': 'Guidance and publications',
            'Economy overview': 'Economy overview',
            'National statistics': 'National statistics',
            'Aid and external resources': 'Aid and external resources',
            'Programmes': 'Programmes',
            'Official resources for suppliers, contractors and members of the public.': 'Official resources for suppliers, contractors and members of the public.',
            'Public procurement': 'Public procurement',
            'Find what you need': 'Find what you need',
            'Procurement resources': 'Procurement resources',
            'Browse tender information, official documents, practical guidance and online procurement services from the Ministry of Finance.': 'Browse tender information, official documents, practical guidance and online procurement services from the Ministry of Finance.',
            'Open resource': 'Open resource',
            'No procurement resources are available at the moment.': 'No procurement resources are available at the moment.',
            'Services and data': 'Services and data',
            'Contact us': 'Contact us',
            'Laws and regulations': 'Laws and regulations',
            'Accessibility': 'Accessibility',
        },
    },
    tet: {
        translation: {
            'An official website of the Democratic Republic of Timor-Leste': 'Website oficial Republika Demokrátika Timor-Leste nian',
            'Skip to main content': 'Ba kontentu prinsipál',
            'Search the portal': 'Buka iha portal',
            'Search': 'Buka',
            'About': 'Kona-ba',
            'Budget & spending': 'Orsamentu no despeza',
            'Procurement': 'Aprovizionamentu',
            'Economy & aid': 'Ekonomia no ajuda',
            'News': 'Notísia',
            'Publications': 'Publikasaun',
            'Contact': 'Kontaktu',
            'Home': 'Inísiu',
            'English': 'Inglés',
            'Tetum': 'Tetum',
            'Português': 'Portugués',
            'Change language, current language {{label}}': 'Muda lian, lian atual {{label}}',
            'Overview and mandate': 'Vizaun jerál no mandatu',
            'Directorates and offices': 'Diretoria no servisu',
            'Development partners': 'Parseiru dezenvolvimentu',
            'Former Ministers': 'Ministru sira uluk',
            'Minister of Finance': 'Ministru Finansas',
            'Organisational structure': 'Estrutura organizasional',
            'Programmes and reform': 'Programa no reforma',
            'Research and analysis': 'Peskiza no análize',
            'Publications and reports': 'Publikasaun no relatóriu',
            'Treasury documents': 'Dokumentu tesouraria',
            'Knowledge centre': 'Sentru koñesimentu',
            'Infographics and posters': 'Infográfiku no poster',
            'Contact the Ministry': 'Kontaktu Ministériu',
            'Careers and vacancies': 'Karreira no vaga servisu',
            'Budget and spending overview': 'Vizaun jerál orsamentu no despeza',
            'Budget and revenue by year': 'Orsamentu no reseita tuir tinan',
            'Revenue collections': 'Kobransa reseita',
            'Tax Authority': 'Autoridade Impostu',
            'Customs Authority': 'Autoridade Alfándega',
            'Budget infographics': 'Infográfiku orsamentu',
            'Open data and statistics': 'Dadus abertu no estatístika',
            'Staff webmail': 'Webmail funsionáriu',
            'LIA AI assistant': 'LIA, asistente AI',
            'Track an invoice': 'Akompaña fatura',
            'Open tenders': 'Licitasaun aberta',
            'open tender': 'licitasaun aberta',
            'open tenders': 'licitasaun aberta',
            'Have your say': 'Fó ita-nia hanoin',
            'Public consultations': 'Konsulta públika',
            'open for comment': 'loke ba komentáriu',
            'e-Procurement Portal': 'Portal e-Aprovizionamentu',
            'Procurement overview': 'Vizaun jerál aprovizonamentu',
            'Current tenders': 'Licitasaun atual',
            'Tender archive': 'Arkivu licitasaun',
            'Register as a supplier': "Rejista nu'udar fornese-dór",
            'Procurement legislation': 'Lei aprovizonamentu',
            'Guidance and publications': 'Orientasaun no publikasaun',
            'Economy overview': 'Vizaun jerál ekonomia',
            'National statistics': 'Estatístika nasionál',
            'Aid and external resources': 'Ajuda no rekursu esternu',
            'Programmes': 'Programa sira',
            'Official resources for suppliers, contractors and members of the public.': 'Rekursu ofisiál ba fornese-dór, kontratante no públiku.',
            'Public procurement': 'Aprovizionamentu públiku',
            'Find what you need': 'Hetan buat ne’ebé ita presiza',
            'Procurement resources': 'Rekursu aprovizonamentu',
            'Browse tender information, official documents, practical guidance and online procurement services from the Ministry of Finance.': 'Buka informasaun licitasaun, dokumentu ofisiál, orientasaun prátika no servisu aprovizonamentu online husi Ministériu Finansas.',
            'Open resource': 'Loke rekursu',
            'No procurement resources are available at the moment.': 'La iha rekursu aprovizonamentu disponivel agora.',
            'Services and data': 'Servisu no dadus',
            'Contact us': 'Kontaktu ami',
            'Laws and regulations': 'Lei no regulamentu',
            'Accessibility': 'Aksibilidade',
        },
    },
    pt: {
        translation: {
            'An official website of the Democratic Republic of Timor-Leste': 'Website oficial da República Democrática de Timor-Leste',
            'Skip to main content': 'Ir para o conteúdo principal',
            'Search the portal': 'Pesquisar no portal',
            'Search': 'Pesquisar',
            'About': 'Sobre',
            'Budget & spending': 'Orçamento e despesas',
            'Procurement': 'Contratação pública',
            'Economy & aid': 'Economia e ajuda',
            'News': 'Notícias',
            'Publications': 'Publicações',
            'Contact': 'Contacto',
            'Home': 'Início',
            'English': 'Inglês',
            'Tetum': 'Tétum',
            'Português': 'Português',
            'Change language, current language {{label}}': 'Alterar idioma, idioma atual {{label}}',
            'Overview and mandate': 'Visão geral e mandato',
            'Directorates and offices': 'Direções e serviços',
            'Development partners': 'Parceiros de desenvolvimento',
            'Former Ministers': 'Antigos Ministros',
            'Minister of Finance': 'Ministro das Finanças',
            'Organisational structure': 'Estrutura organizacional',
            'Programmes and reform': 'Programas e reforma',
            'Research and analysis': 'Investigação e análise',
            'Publications and reports': 'Publicações e relatórios',
            'Treasury documents': 'Documentos do Tesouro',
            'Knowledge centre': 'Centro de conhecimento',
            'Infographics and posters': 'Infografias e cartazes',
            'Contact the Ministry': 'Contactar o Ministério',
            'Careers and vacancies': 'Carreiras e vagas',
            'Budget and spending overview': 'Visão geral do orçamento e despesas',
            'Budget and revenue by year': 'Orçamento e receitas por ano',
            'Revenue collections': 'Cobrança de receitas',
            'Tax Authority': 'Autoridade Tributária',
            'Customs Authority': 'Autoridade Aduaneira',
            'Budget infographics': 'Infografias do orçamento',
            'Open data and statistics': 'Dados abertos e estatísticas',
            'Staff webmail': 'Webmail dos funcionários',
            'LIA AI assistant': 'LIA, assistente de IA',
            'Track an invoice': 'Acompanhar uma fatura',
            'Open tenders': 'Concursos abertos',
            'open tender': 'concurso aberto',
            'open tenders': 'concursos abertos',
            'Have your say': 'Dê a sua opinião',
            'Public consultations': 'Consultas públicas',
            'open for comment': 'abertas a comentários',
            'e-Procurement Portal': 'Portal de e-Procurement',
            'Procurement overview': 'Visão geral da contratação pública',
            'Current tenders': 'Concursos atuais',
            'Tender archive': 'Arquivo de concursos',
            'Register as a supplier': 'Registar como fornecedor',
            'Procurement legislation': 'Legislação de contratação pública',
            'Guidance and publications': 'Orientações e publicações',
            'Economy overview': 'Visão geral da economia',
            'National statistics': 'Estatísticas nacionais',
            'Aid and external resources': 'Ajuda e recursos externos',
            'Programmes': 'Programas',
            'Official resources for suppliers, contractors and members of the public.': 'Recursos oficiais para fornecedores, contratantes e o público.',
            'Public procurement': 'Contratação pública',
            'Find what you need': 'Encontre o que precisa',
            'Procurement resources': 'Recursos de contratação pública',
            'Browse tender information, official documents, practical guidance and online procurement services from the Ministry of Finance.': 'Consulte informações sobre concursos, documentos oficiais, orientações práticas e serviços de contratação pública online do Ministério das Finanças.',
            'Open resource': 'Abrir recurso',
            'No procurement resources are available at the moment.': 'Não existem recursos de contratação pública disponíveis neste momento.',
            'Services and data': 'Serviços e dados',
            'Contact us': 'Contacte-nos',
            'Laws and regulations': 'Leis e regulamentos',
            'Accessibility': 'Acessibilidade',
        },
    },
};

const savedLanguage = window.localStorage.getItem('mof-language');

i18n.init({
    resources,
    lng: savedLanguage || 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
});

export default i18n;
